import React from "react";

import { WarningFilled } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useHistory } from "react-router-dom";

import { getUsageMetricsBuildPlanPath } from "../../MyAccount/UsageMetrics/constants";

import { canMakePayment } from "../../../utils/Permissions";
import { canViewUsageMetrics } from "../../MyAccount/UsageMetrics/utils";

import "./NoTestCreditsBanner.css";

const USAGE_METRICS_PERMISSION_TOOLTIP = "Requires Usage Metrics Permission";

export default function NoTestCreditsBanner() {
  const history = useHistory();
  const allowPayment = canMakePayment();
  const buyCreditsDisabled = !canViewUsageMetrics();

  return (
    <div className="NoTestCreditsBanner" role="status">
      <WarningFilled className="NoTestCreditsBanner__Icon" aria-hidden />
      <div className="NoTestCreditsBanner__Copy">
        <p className="NoTestCreditsBanner__Title">No Test Credits Available</p>
        <p className="NoTestCreditsBanner__Description">
          {allowPayment
            ? "Purchase test credits to submit new samples."
            : "Contact your account admin to purchase test credits."}
        </p>
      </div>
      {allowPayment && (
        <div className="NoTestCreditsBanner__Actions">
          <Tooltip title={buyCreditsDisabled ? USAGE_METRICS_PERMISSION_TOOLTIP : ""}>
            <span className="NoTestCreditsBanner__ButtonWrap">
              <Button
                type="primary"
                size="small"
                className="NoTestCreditsBanner__Button"
                disabled={buyCreditsDisabled}
                onClick={() => history.push(getUsageMetricsBuildPlanPath())}
              >
                Buy Test Credits
              </Button>
            </span>
          </Tooltip>
        </div>
      )}
    </div>
  );
}
